{ "id": "la-gonflable", "name": "La Gonflable", "sprite": "la-gonflable", "hp": 50, "speed": 230, "radius": 14, "lifetime": 10, "maxActive": 1, "behavior": "healer", "heal": { "amount": 8, "interval": 1, "radius": 200 } }
